import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { CarrierService } from 'src/app/services/carrier/carrier.service';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { RequestAccessTypesEnum } from 'src/app/shared/enum/request-access-types.enum';
import * as _ from 'lodash';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { ConfirmUserRequestAccessComponent } from '../confirm-request-access/confirm-user-request-access.component';
import { RegexEnum } from 'src/app/core/enum/regex.enum';

@Component({
  selector: 'carrier-user-request-access',
  templateUrl: './carrier-user-request-access.component.html',
  styleUrls: ['./carrier-user-request-access.component.scss']
})
export class CarrierUserRequestAccessComponent implements OnInit {

  public invalidAccess: boolean = false;
  public viewRequestAccessPage: boolean = true;
  public newCarrierUserRequest: any = {};
  private token: any;
  public loading: boolean = false;
  public phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  public regexEnum = RegexEnum;

  constructor(
    private route: ActivatedRoute,
    public carrierService: CarrierService,
    private flashMessageService: FlashMessageService,
    private location: Location,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
    });
    if (!this.token) {
      this.invalidAccess = true;
      this.viewRequestAccessPage = false;
    }
    this._validateToken();
  }

  public back() {
    this.location.back();
  }

  private _validateToken() {
    this.loading = true;
    this.carrierService.validateToken("validate", this.token)
      .then((userInfo: any) => {
        this.loading = false;
        if (!_.isEmpty(userInfo) && userInfo.status && userInfo.status !== 'Success') {
          this.invalidAccess = true;
          this.viewRequestAccessPage = false;
          return;
        }
        if (!_.isEmpty(userInfo)) {
          this.newCarrierUserRequest = {
            organization_id: userInfo.carrierId,
            firstName: userInfo.firstName,
            lastName: userInfo.lastName,
            email: userInfo.emailAddress,
            roleCode: userInfo.role,
            carrierName: userInfo.carrierName,
            phone: userInfo.phoneNumber || ''
          }
        }
      })
      .catch(error => {
        this.loading = false;
        this.flashMessageService.updateMessage(`Error validating User`, 5000, "danger");
      });
  }

  onSubmit() {
    this.loading = true;
    this.carrierService.createCarrierRequest(this.newCarrierUserRequest, this.token)
      .then((response: any) => {
        this.loading = false;
        if (!_.isEmpty(response)) {
          this.dialog.open(
            ConfirmUserRequestAccessComponent,
            {
              data: {
                email: this.newCarrierUserRequest.email,
                token: this.token
              }
            });
        }
      })
      .catch((error) => {
        this.loading = false;
        this.flashMessageService.updateMessage(error);
      });
  }

  completeMigration() {
    this.dialog.open(ConfirmUserRequestAccessComponent, {
      data: {
        token: this.token,
      },
    });
  }
}

